export default "__VITE_ASSET__rliylyYI__"